export default {
  methods: {
    getGymStatusText(isActive = false) {
      return isActive ? 'Занят' : 'Свободен'
    },
    getGymStatusColor(isActive = false) {
      return isActive ? 'red' : 'green'
    }
  }
}